import { useTranslation } from '@frontend/i18n';
import { Chip } from '@frontend/design-system';
import { styles } from '../styles';
import { InvoiceCardDetailsProps } from '../types';

export const InvoiceCardDetails = ({
  className,
  children,
  invoice,
  formattedBilledAt,
  billedAtData,
  formattedBilledAmount,
  formattedOwedAmount,
}: InvoiceCardDetailsProps) => {
  const { t } = useTranslation();

  return (
    <div className={`card ${className || ''}`} css={styles.card}>
      <div className='card__header' css={styles.header}>
        <div className='card__date' css={styles.date}>
          {formattedBilledAt}
        </div>
        <div className='card__date-chip'>
          <Chip variant={billedAtData.variant}>{billedAtData.daysPassedLabel}</Chip>
        </div>
      </div>
      <div className='card__info-blocks' css={styles.infoBlocks()}>
        <div className='card__info-block' css={styles.infoBlock}>
          <label>{t('Amount')}</label>
          <div>{formattedBilledAmount}</div>
        </div>
        <div className='card__info-block' css={styles.infoBlock}>
          <label>{t('Owed')}</label>
          <div>{formattedOwedAmount}</div>
        </div>
        <div className='card__info-block' css={styles.infoBlock}>
          <label>{t('Provider')}</label>
          <div>{invoice.providerName || t('N/A')}</div>
        </div>
      </div>
      <div className='card__body'>{children}</div>
    </div>
  );
};
